
import { defineComponent } from "vue";

/**
 * TODO
 *  ・lazyload
 *    ・現状、imgの画像の指定をdata-srcからsrcに変更してしまっている
 */
export default defineComponent({
  name: "App",
  components: {},
});
